import {
  type RunHistoryKeyInfo,
  type RunHistoryKeyType,
} from '../../../types/run';
import * as RunHelpers from '../../../util/runhelpers';
import {useKeyInfoQueryContext} from '../../MultiRunWorkspace/KeyInfoQueryContext';
import {useProjectIsV2} from '../ProjectDetails';
import {type RunsLinePlotConfig} from '../types';
import {useXYChoices} from './useXYChoices';

export type HistoryKeysAxisChoices = {
  keyInfo: RunHistoryKeyInfo;
  keyTypes: {[key: string]: RunHistoryKeyType};
  xAxisChoices: string[];
  yAxisChoices: string[];
  fromV2: boolean;
};

/**
 * Shared history-key derivations for the x/y axis pickers
 */
export function useHistoryKeysAxisChoices({
  config,
  xAxis,
  isSingleRun,
  entityName,
  projectName,
}: {
  config: RunsLinePlotConfig;
  xAxis: string;
  isSingleRun: boolean;
  entityName: string;
  projectName: string;
}): HistoryKeysAxisChoices {
  const {
    keyInfoQuery: {historyKeyInfo: keyInfo},
  } = useKeyInfoQueryContext();

  const keyTypes = RunHelpers.useKeyTypes(keyInfo.keys);
  const {xAxisChoices, yAxisChoices} = useXYChoices({
    config,
    keyInfo,
    keyTypes,
    isSingleRun,
    xAxis,
  });
  const {fromV2} = useProjectIsV2({entityName, projectName});

  return {
    keyInfo,
    keyTypes,
    xAxisChoices,
    yAxisChoices,
    fromV2: Boolean(fromV2),
  };
}
